<template>
  <div>
    <Nav
      :rType="4"
      @Data="Datas"
      @sousuoxinxi='sousuoxinxi'
    ></Nav>
    <div style="height: 80px"></div>
    <Longin v-show="longin" :long="longin" @longi="longins"></Longin>
    <div class="search_home">
      <div class="home-bottom" v-if="Data">
        <div class="home-right">
          <div v-show="content2" class="search_user_list">
            <div
              v-for="(item, index) in content"
              :key="index"
              @click="navTopath(item.uid,item.isLive,item.virtualId)"
              class="home-right-content"
            >
              <div v-if="item.isLive == 1" class="onliveroom">
                  <img src="https://oss.ansongqiubo.com/assets/roomlive/live_status.png">
              </div>
              <img
                
                :src="item.avatar"
                alt=""
              />
              <div class="user_name">
                <span>{{ item.nickname | ellipsis }}</span>
              </div>
              <div class="guanzhu">
                <span style="color: #a6a6a6">关注{{ item.follows }}｜</span
                ><span style="color: #a6a6a6">粉丝{{ item.fans }}</span>
              </div>
              <div @click.stop="quguanzhuobo(item.uid)" v-if="item.followStatus == 2" class="btn_allgunazhu">
                互相关注
              </div>
              <div @click.stop="quguanzhuobo(item.uid)" v-if="item.followStatus == 1" class="btn_unguanzhu">
                已关注
              </div>
              <div
                @click.stop="guanzhu(item.uid)"
                v-if="item.followStatus == 0"
                class="btn_guanzhu"
              >
                + 关注
              </div>
              <!-- <div v-show="guanzhu2" style="margin:10px auto;text-align: center;width: 91px;height: 40px;background:rgb(218, 218, 218);border-radius: 4px;font-size: 18px;line-height: 40px;color:#666666;">已关注</div> -->
            </div>
          </div>
          <div
            v-show="yincang"
            style="
              display: flex;
              flex-direction: column;
              width: 1200px;
              min-height: 400px;
              justify-content: center;
              align-items: center;
              text-align: center;
            "
          >
             <img style="
             width: 234px;
             height: 126px;
             " src="https://oss.ansongqiubo.com/assets/search/lack_wusousuojieguo@2x.png" alt="" srcset="">
          <div style="font-size: 14px; color: #666;" class="txt">暂无搜索结果</div>
          </div>
        </div>
      </div>
      <div v-else class="emit_data">
           <img style="
             width: 234px;
             height: 126px;
             " src="https://oss.ansongqiubo.com/assets/search/lack_wusousuojieguo@2x.png" alt="" srcset="">
          <div style="font-size: 14px; color: #666;" class="txt">暂无搜索结果</div>
      </div>
    </div>
  </div>
</template>
<script>
// import axios from 'axios'
import Nav from "../component/Nav.vue";
import qs from "qs";
import Longin from "../component/Longin.vue";
export default {
  inject: ["reload"],
  data() {
    return {
      a: "",
      b: "",
      Data: [],
      fenlei1: 0,
      content: [], //搜索结果数据
      yincang: false,
      yincang2: true,
      guanzhu2: false,
      longin: false,
      content2: false,
      Sousuo: "", //搜索信息
    };
  },
  mounted() {
    // 分类列表
    this.initdatas()

    // this.content = this.$route.query.data2;
    this.Sousuo = this.$route.query.data3;
    // console.log(this.Sousuo);
    // this.content = this.$route.query.data2;
    this.content = sessionStorage.getItem('searchData')?JSON.parse(sessionStorage.getItem('searchData')):[]
    console.log(this.content);
    if (this.content.length == 0) {
      this.yincang = true;
      this.content2 = false;
    } else {
      this.yincang = false;
      this.content2 = true;
    }

    this.sousuoxinxi();
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 8) {
        return value.slice(0, 8) + "...";
      }
      return value;
    },
  },
  methods: {
    navTopath(uid,like,virtualId){
      if (like == 1) {
        const neww = this.$router.resolve({
          path: "/roominfo",
          query: { roomId: uid ,virtualId},
        });
        window.open(neww.href, "_self");
      } else {
		if(localStorage.getItem('toekn')){
			this.$router.push({
			  path: "/yonghuyemian",
			  query: { uid: uid },
			});
		}
      }
    },
    initdatas(){
    const that = this;

      that.$axios
      .get(that.api + "/v1/list/categories/all", {
        params: {},
        headers: {
          device: "web",
          packageId: "1",
          channel: "web",
          version: "1.0.0",
        },
      })
      .then((res) => {
        that.Data = res.data.data;
      });
    },
    Datas(e) {
      //console.log(e);
      this.content = e;
      if (this.content.length == 0) {
        this.yincang = true;
        this.content2 = false;
      } else {
        this.yincang = false;
        this.content2 = true;
      }
      //console.log(this.content);
    },
    sousuoxinxi(ee) {
      if(ee)
      this.Sousuo = ee;
      //console.log(this.Sousuo);
    },
    Fenlei1(index) {
      this.fenlei1 = index;
      this.$router.push("/");
      // this.$router.resolve({path:'/', query: {indexx:index}})
    },
    longins(e) {
      this.longin = e;
    },
        // 用户取关主播
    quguanzhuobo(uid) {
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            return data;
          },
        ],
        url: this.api + "/v1/relation/unfollow",
        method: "post",
        data: {
          actionUid:uid,
        },
      }).then((res) => {
        //   console.log(res);
        if (res.data.message == "success") {
            this.$axios({
              url: this.api + "/v1/list/search/user?nickname=" + this.Sousuo,
              method: "GET",
              headers: {
                device: "web",
                packageId: "1",
                version: "1.0.0",
                channel: "web",
                "authToken": localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            }).then((res) => {
              //console.log(res);
              this.content = res.data.data;
                 this.$message({
                  message: "取关成功",
                  type: "success",
                });
            });
        }
      });
    },
    // 关注搜索的用户
    guanzhu(e) {
      // window._czc.push(['A0103', contentUrl, refererUrl])
      //console.log(e);
      if (localStorage.getItem("token")) {
        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function (data) {
              //在请求之前对data传参进行格式转换
              data = qs.stringify(data);
              return data;
            },
          ],
          url: this.api + "/v1/relation/follow",
          method: "post",
          data: {
            actionUid: e,
          },
        }).then((res) => {
          //console.log(res);
          if (res.data.message == "success") {
            this.guanzhu2 = true;
            this.yincang2 = false;
            console.log(this.Sousuo);
            this.$axios({
              url: this.api + "/v1/list/search/user?nickname=" + this.Sousuo,
              method: "GET",
              headers: {
                device: "web",
                packageId: "1",
                version: "1.0.0",
                channel: "web",
                "authToken": localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            }).then((res) => {
              //console.log(res);
              this.content = res.data.data;
                 this.$message({
                  message: "关注成功",
                  type: "success",
                });
            });
          }
        });
      } else {
        this.longin = true;
      }
    },
  },
  components: {
    Nav,
    Longin,
  },
};
</script>

<style scoped lang='scss'>
.a {
  background: #672dd4;
  color: white;
  /* font-size:1.5em; */
  /* height: 18px;
  width: 18px; */
}
.search_home {
  width: 100%;
  user-select: none;
  height: calc(100vh - 80px);
  background: #f7f8fa;
  position: relative;
  display: flex;
  justify-content: center;
  font-size: 16px;
  .home-bottom {
    margin-top: 12px;
    max-width: 1200px;
    width: 100%;
    display: flex;
  }
  .emit_data{
    transform: translateY(-100px);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .txt{
      margin-top: 10px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    img{
      width: 300px;
      height: 161px;
    }
  }
}
.home-right {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  box-sizing: border-box;
  .search_user_list {
    display: flex;
    flex-flow: row wrap;
    .home-right-content {
        transition: all .2s;

      width: 190px;
      height: 204px;
      background: #ffffff;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 12px 12px 0;
      position: relative;
      cursor: pointer;
      .btn_allgunazhu {
        width: 86px;
        margin-top: 16px;

        height: 34px;
        background: linear-gradient(270deg, #f75325 0%, #ed1010 100%);
        border-radius: 17px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 34px;
      }
      .btn_guanzhu {
        margin-top: 16px;
        width: 86px;
        height: 34px;
        background: linear-gradient(270deg, #f75325 0%, #ed1010 100%);
        border-radius: 17px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 34px;
      }
      .btn_unguanzhu {
        margin-top: 16px;

        width: 86px;
        height: 34px;
        background: #b3b3b3;
        border-radius: 17px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: center;
        line-height: 34px;
        color: #ffffff;
      }
      .guanzhu {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      .user_name {
        margin-top: 10px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
      img {
        margin-top: 24px;
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
      .onliveroom {
        height: 18px;
        border-radius: 2px;
        text-align: center;
        line-height: 18px;
        position: absolute;
        padding: 1px 4px;
        top: -10px;
        left: 8px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        img{
          width:50px;
          height: 16px;
          border-radius: 0;
        }
      }
    }
    .home-right-content:nth-child(6n) {
      margin-right: 0 !important;
    }
    .home-right-content:hover{
        box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
        transition: all .2s;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/component/search.vue